module.exports = __webpack_public_path__ + "img/bottom.d93b0911.png";